import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { Section } from 'common';
import strings from 'strings';
import { filterValidItems, isTruthyValue } from 'utils';

import { DescriptionText } from '../../styles';

export const Education = ({ educations = [] }) => {
  const validEducations = filterValidItems(educations);
  if (validEducations.length === 0) return null;

  return (
    <Section title={strings.candidates.profile.resumeTab.sections.education}>
      <List disablePadding>
        {validEducations.map(education => {
          const {
            degree,
            description,
            end_year: endDate,
            start_year: startDate,
            issuing_organization: organization
          } = education;

          const formattedPeriod = startDate && endDate ? `${startDate}/${endDate}` : '';

          return (
            <ListItem key={`${organization}-${formattedPeriod}`} disableGutters>
              <ListItemText
                primary={
                  <>
                    {isTruthyValue(organization) && (
                      <Typography color="textSecondary">{organization}</Typography>
                    )}

                    {isTruthyValue(degree) && (
                      <Typography>
                        <b>{degree}</b>
                      </Typography>
                    )}

                    {isTruthyValue(description) && (
                      <DescriptionText component="pre">{description}</DescriptionText>
                    )}

                    {isTruthyValue(formattedPeriod) && (
                      <Typography color="textSecondary">{formattedPeriod}</Typography>
                    )}
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Section>
  );
};
